<template>

    <div class="order order-item order-subgrid">

        <div class="date">
            <FTag v-if="!order.live" style="display: inline-flex; background-color: red;">{{ $vt('TEST') }}</FTag>
            {{ order.date * 1000 | angularFilter('d/MM/yyyy', 'date') }}
        </div>
        <div class="description">
            {{ order.description }} <span v-if="order.quantity > 1"> x {{ order.quantity }}</span>
        </div>
        <div class="cost positive" v-if="order.status === 'paid'">
            <StripePrice :price="order.amount_paid" />
        </div>
        <div class="cost negative" v-else>
            <StripePrice :price="order.amount_due" />
        </div>

        <div class="invoice" v-if="order.status === 'paid'">
            <FButton type="tertiary " :href="order.invoice_pdf" blank>
                {{ $vt('Invoice') }}
                <FIcon icon="fa6-circle-down" />
            </FButton>
        </div>
        <div class="invoice" v-else>
            <FButton type="tertiary negative" :href="order.hosted_invoice_url" blank>
                {{ $vt('Proceed to payment') }}
                <FIcon icon="fa6-circle-down" />
            </FButton>
        </div>
    </div>

</template>
<script>

import { stripePriceToString } from '~/stripe.utils.mjs'

import StripePrice from '~/main/components/StripePrice.vue';

export default {
    components: {
        StripePrice
    },
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    translate25Context: 'stripe.orders'
}
</script>

<style lang="scss">
.stripe-order-invoices {
    .order-item {
        display: grid;
        // align-items: center;


        font-family: Lato;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;



        >*.positive {
            color: var(--statusPositive);
        }

        >*.negative {
            color: var(--statusNegative);
        }

    }
}
</style>